/* eslint-disable no-param-reassign */
import { setUniversalError } from 'features/liveReport/liveReportSlice'
import { ToolkitStore } from '@reduxjs/toolkit/dist/configureStore'
import liveReportService from './instance'
import { UNIVERSAL_ERROR_CODES } from './errorCodes'

const isRelease = process.env.REACT_APP_IS_RELEASE === 'true'

let store: ToolkitStore
// eslint-disable-next-line import/prefer-default-export
export const injectStore = (_store: any) => {
  store = _store
}

liveReportService.interceptors.request.use(
  (config) => {
    config.headers['X-Report-Id'] = store.getState().liveReport.reportId || ''
    if (!isRelease) {
      // X-Build-Name determines which LiveReportService build to call.
      config.headers['X-Build-Name'] = store.getState().liveReport.buildName || ''
    }
    config.headers['X-Csrf-Token'] = store.getState().liveReport.csrfTokenState.token || ''
    return config
  },
  (error) => Promise.reject(error)
)

liveReportService.interceptors.response.use(
  (response) => response,
  (error) => {
    const errorCode = error.response?.data?.status
    if (UNIVERSAL_ERROR_CODES.includes(errorCode)) {
      store.dispatch(setUniversalError(error.response.data))
    }
    return Promise.reject(error)
  }
)
